"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
function AnimatedCounter({
  value,
  isVisible
}: {
  value: number;
  isVisible: boolean;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (isVisible) {
      let start = 0;
      const end = value;
      const duration = 2000;
      const increment = end / (duration / 16);
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.ceil(start));
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isVisible, value]);
  return <span>{count}</span>;
}
export default function ReliabilityByTheNumbers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2,
    once: true
  });
  const stats = [{
    value: 70,
    suffix: "HP",
    label: "Potencia Compacta"
  }, {
    value: 100,
    suffix: "HP",
    label: "Rendimiento Versátil"
  }, {
    value: 110,
    suffix: "HP",
    label: "Máxima Tracción"
  }, {
    value: 4,
    suffix: "x4",
    label: "Grúas Horquilla"
  }];
  return <section data-section-id="224935" id="rendimiento-en-cifras" className="w-full bg-background text-foreground py-16 md:py-24 overflow-hidden relative">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)`,
      backgroundSize: '4rem 4rem'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, i) => <div key={i} data-index={i} className={cn("flex flex-col items-center justify-center py-12 px-6 text-center", "border-primary/20 transition-colors duration-700", "border-b last:border-b-0", "md:border-b-0 md:border-r md:last:border-r-0", "md:max-lg:[&:nth-child(2n)]:border-r-0", "md:max-lg:[&:nth-child(1)]:border-b md:max-lg:[&:nth-child(2)]:border-b")}>
              <div className="flex items-start justify-center mb-3">
                <span className="text-6xl md:text-7xl lg:text-8xl font-bold tracking-tighter font-default text-primary drop-shadow-lg">
                  <AnimatedCounter value={stat.value} isVisible={isVisible} />
                </span>
                <span className="text-xl md:text-2xl lg:text-3xl font-semibold text-primary/80 mt-2 ml-1 font-default">
                  {stat.suffix}
                </span>
              </div>
              <div className="font-mono text-xs md:text-sm uppercase tracking-widest text-foreground/60">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}